import script from "./sub-device-command-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./sub-device-command-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./sub-device-command-drawer.vue?vue&type=style&index=0&id=31fa544d&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fa544d"]])

export default __exports__